import useSiteMetadata from './useSiteMetadata'
import useUserCategory from './useUserCategory'

export interface UseRetailPrices {
  shouldDisplayRetailPrice: boolean
}

const useRetailPrices = (): UseRetailPrices => {
  const { userCategory } = useUserCategory()
  const { featureFlags } = useSiteMetadata() || {}

  return {
    shouldDisplayRetailPrice:
      (featureFlags?.showRetailPrices ?? false) && userCategory === 'practitioner',
  }
}

export default useRetailPrices
